<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">全部订单</h1>-->
    <!--</header>-->
    <nav class="mui-bar mui-bar-tab" style="padding: 0px;">
      <button class="mui-btn-blue btn-blue filter-btn" @click="filter()">
        <span class="mui-icon iconfont icon-filter" style="vertical-align: middle;"></span>
        <span style="vertical-align: middle;">筛选</span>
      </button>
    </nav>
    <div class="mui-content pd-8" style="bottom: 50px;">
      <div class="title-name" style="margin-bottom: 15px;">
         <span class="">全部订单</span>
         <div class="total-div">
            <div class="total-text">条</div>
            <div class="total-text total-text-strong">{{total}}</div>
            <div class="total-text">共</div> 
          </div>
      </div>
      <!-- TAB -->
      <div class="tab-container">
        <div class="tab-header">
          <div 
            v-for="(tab, index) in tabs"
            :key="index"
            @click="tabclick(index)"
            :class="{ active: activeTab === index, disactive: activeTab !== index}"
          >
            {{ tab.title }}
          </div>
        </div>
        <div class="tab-content">
          <!--第一个-->
          <div class="content mui-table-view" id="content" v-show="infoLst.length > 0">
            <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :autoFill="false" ref="loadmore" :top-method="loadTop">
              <div class="flex-content" v-for="(item,i) in infoLst" style="margin-top: 10px;" :key="i">
                <div class="flex-box" style="padding-right: 2px;">
                  <div class="flex-container">
                    <div class="flex-content-container">
                      <div class="flex-content-label">订单编号:</div>
                      <div class="flex-content-span flex-1">{{item.ddh}}</div>
                    </div>
                    <div class="flex-content-container" style="display: block;">
                      <div class="flex-content-label flex-content-span flex-strong flex-1" style="padding-right:15px;" >{{item.zt}}</div>
                      <div class="flex-content-span flex-1" style="font-weight:bold;">No:{{i+1}}</div>
                    </div>
                  </div>
                  <div class="flex-container">
                    <div class="flex-content-container">
                      <div class="flex-content-label">物料:</div>
                      <div class="flex-content-span flex-1" style="word-wrap:break-word; word-break:normal;">{{item.info}}</div>
                    </div>
                  </div>
                  <div class="flex-container">
                    <div class="flex-content-container">
                      <div class="flex-content-label">交货日期:</div>
                      <div class="flex-content-span flex-1">{{item.hyqdhrq}}</div>
                    </div>
                    <!-- <div class="flex-content-container" style="display: block;">
                      <div class="flex-content-label" style="width:0px;min-width: 0px;" ></div>
                      <div class="flex-content-span flex-strong flex-1" style="color:#e98835;" v-if="(item.qi_closeflg == '1')">{{(item.qi_closeflg == '1') ? '可检' : '不可检'}}</div>
                      <div class="flex-content-span flex-strong flex-1" style="color:#ff0000;" v-else>{{(item.qi_closeflg == '1') ? '可检' : '不可检'}}</div>
                    </div> -->
                    <!-- 当前状态: -->
                  </div>
                  <div class="flex-container">
                    <div class="flex-content-container">
                      <div class="flex-content-label" >已入库:</div>
                      <div class="flex-content-span flex-1">{{item.yrksl}}{{item.dw}}</div>
                    </div>
                  </div>
                  <div class="flex-container" style="justify-content: flex-end;margin-right:10px;margin-top: -25px;" v-if="item.zt != '已完成' && item.qicloseauthflg">
                    <button class="cfirmbtn" @click.stop="onQIClick(item)">{{(item.qi_closeflg == '1') ? '关闭质检' : '启用质检'}}</button>
                  </div>
                </div>
              </div>
            </mt-loadmore>
          </div>
          <div class="empty_div" v-show="infoLst.length <= 0" >
            <div>暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "orderList",
  data() {
    return {
      infoLst: [],
      searchifo: null,
      total: 0, // 总条数
      pageIdx: 1, // 第几页
      pageSize: 5, // 每页条数
      allLoaded: false, // 是否全部加载完毕
      tabs:[{
        title:"全部",
        value:""
      },{
        title:"待确认",
        value:"0"
      },{
        title:"加工中",
        value:"1"
      }],
      activeTab: 0
    }
  },
  created() {
    var v = this;
    // v.searchifo = null;
    v.pageInit();
    v.eventBus.$on('searchifo', function(data) {
      if (data) {
        v.searchifo = data;
      }
    }.bind(this));
  },
  activated() {
    //this.query();
    this.newSearch();
  },
  methods: {
    pageInit() {
      var v = this;
      v.searchifo = null;
      v.infos = [];
      v.total = 0;
      v.pageIdx = 1;
      v.pageSize = 5;
    },
    filter() {
      this.$router.push({ "name": "orderFilter", params: jsonPara(this.searchifo) });
    },
    query(callback) {
      var v = this;
      v.nyy.doPost("/Order/getOrderList", {
          ddh: v.searchifo?v.searchifo.ddh:"",
          scxtwpmc: v.searchifo?v.searchifo.scxtwpmc:"",
          contractdate_fr: v.searchifo?v.searchifo.contractdate_fr:"",
          contractdate_to: v.searchifo?v.searchifo.contractdate_to:"",
          hyqdhrq: v.searchifo?v.searchifo.hyqdhrq:"",
          rawprovideflag: v.searchifo?v.searchifo.rawprovideflag:"",
          zt: v.searchifo?(v.searchifo.zt==true?'1':''):"",
          pageSize: v.pageSize,
          pageIdx: v.pageIdx,
          orderstatus: v.tabs[v.activeTab].value
        },
        function(result) {
          if (result.status) {
            v.infoLst = v.infoLst.concat(result.data.infoLst || []);
            v.total = result.data.total;
            if (v.pageIdx * v.pageSize >= v.total) {
              // 数据已全部获取完毕
              v.$refs.loadmore.onBottomLoaded();
              v.allLoaded = true;

              v.$nextTick(function() {
                if (v.pageSize >= v.total) {
                  document.getElementById('content').scrollTop = 0;
                }
              });
            }
          }
          if (callback) callback();
        }
      );
    },
    newSearch() {
      var v = this;
      v.infoLst = [];
      v.pageIdx = 1;
      v.total = 0;
      v.allLoaded = false;
      v.query();
    },
    // 加载更多履历
    loadBottom() {
      var v = this;
      var size = v.pageSize;
      var page = v.pageIdx++;

      if (page * size < v.total && page * size > 0) {
        v.query(() => {
          v.$refs.loadmore.onBottomLoaded();
        });
      } else {
        // 数据已全部获取完毕
        v.$refs.loadmore.onBottomLoaded();
        v.allLoaded = true;
      }
    },
    loadTop(){
      const v =  this;
      v.infoLst = [];
      v.pageIdx = 1;
      v.total = 0;
      v.allLoaded = false;

      v.query(function(){
        v.$refs.loadmore.onTopLoaded(); // 通知加载完成
      });
    },
    onQIClick(item){
      const v = this;
      let msg = (item.qi_closeflg == '1') ? '质检关闭' : '质检启用';
      // 质检
      let apiname = (item.qi_closeflg == '1') ? "/Order/SetContractQiFlgDisable" :"/Order/SetContractQiFlgEnable";
      // 确认
      mui.confirm('确定' + msg + '？', '提示', ['否', '是'], function(e) {
        if (e.index == 1) {
          v.nyy.doPost(apiname, {
              ddh: item.ddh,
              wph: item.wph
            },
            function(result) {
              if (result.status) {
                v.querydetail(item, function(infolist){
                    mui.alert("处理成功", "消息提示", () => {
                      let newList = infolist || [];
                      if(newList.length > 0){
                        let newinfo = newList[0];
                        let currentIdx = 0;
                        v.infoLst.forEach((option,idx) => {
                          if(newinfo.ddh == option.ddh && newinfo.wph == option.wph){
                              currentIdx = idx;
                          }
                        });
                        v.$set(v.infoLst, currentIdx, newinfo);
                      }
                    });
                  });
              } else {
                mui.toast(result.message);
              }
            }
          );
        }
      });
    },
    querydetail(item,callback) {
      var v = this;
      v.nyy.doPost("/Order/getOrderList", {
          ddh: item.ddh,
          wph: item.wph,
          scxtwpmc: "",
          contractdate_fr: "",
          contractdate_to: "",
          hyqdhrq: "",
          rawprovideflag: "",
          zt: "",
          pageSize: 0,
          pageIdx: 0
        },
        function(result) {
          if (result.status) {
            if (callback) callback(result.data.infoLst);
          }
        }
      );
    },
    tabclick(index){
      const v = this;
      v.activeTab = index;
      document.getElementById('content').scrollTop = 0;
      v.newSearch();
    }
  }
}
</script>
<style scoped>
.content {
  width: 100%;
  height: -webkit-calc(100% - 100px);
  height: calc(100% - 100px);
  overflow: scroll;
  padding: 10px;
}
.cfirmbtn{
  background-color: #0062CC;
  color: white;
  border: 0px;
  border-radius: 5px;
  margin-bottom: 5px;
}
.flex-content{
  border:1px solid #1F6FB5;
}
.tab-container {
  border-radius: 4px;
  height: -webkit-calc(100% - 10px);
  height: calc(100% - 10px);
  /* touch-action: none; */
}

.tab-header {
  display: flex;
  border: 1px solid #eee;
  border-radius: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.tab-header div {
  padding: 10px 20px;
  font-size: 14px;
  color: #404040;
  width: 33.3%;
  text-align: center;
  cursor: pointer;
  border-right: 1px solid #ecebeb;
}

.tab-header div.active {
  /* background: #0062CC; */
  color: #0062CC;
  font-weight: bold;
  /* font-weight: bold; */
  font-size: 14px;
  border-bottom: 2px solid #0062CC;
}

.tab-header div.disactive {
  background-color: #f8f8f8;
}

.tab-content {
  /* padding: 20px; */
  overflow-y: auto; 
  height: -webkit-calc(100% - 0px);
  height: calc(100% - 0px);
}
.mui-content {
  overflow-y: hidden !important;
}
.empty_div {
  text-align: center;
  padding-top: 80px;
  font-size: 14px;
  color: #404040;
}
.total-div {
  margin-left: 10px;
  margin-right: 10px;
  text-align: right;
  line-height: 30px;
  height: 30px;
  padding-top: 5px;
  font-size: 14px;
}
.total-text {
  position: relative;
  float: right;
}
.total-text-strong {
  color: #0062CC;
  font-weight: bold;
  margin-left: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderList.vue